import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { CHANNEL_VIA_PARAMS } from '@/features/msg-channels/common/msg-channels.types';

export const Route = createFileRoute('/_channels/channels/onboarding')({
  validateSearch: z.object({
    via: z.enum(CHANNEL_VIA_PARAMS).optional().catch(undefined),
  }),
  beforeLoad: ({ search }) => {
    if (!search.via) {
      throw redirect({ to: '/channels/connect', replace: true });
    }
  },
});
